var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip0_8019_192347)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.2059C10 20.3178 10.9 21.2275 12 21.2275C13.1 21.2275 14 20.3178 14 19.2059C14 18.0939 13.1 17.1842 12 17.1842C10.9 17.1842 10 18.0939 10 19.2059ZM10 5.0541C10 6.16602 10.9 7.07578 12 7.07578C13.1 7.07578 14 6.16602 14 5.0541C14 3.94217 13.1 3.03242 12 3.03242C10.9 3.03242 10 3.94217 10 5.0541ZM10 12.13C10 13.2419 10.9 14.1517 12 14.1517C13.1 14.1517 14 13.2419 14 12.13C14 11.0181 13.1 10.1083 12 10.1083C10.9 10.1083 10 11.0181 10 12.13Z",
    fill: "#656565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8019_192347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2602,
    height: 24,
    fill: "white",
    transform: "translate(0 24.2603) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.f327c1c3c6841de81754f1d559a3a2e3.svg";
export { ForwardRef as ReactComponent };